<div style="text-align: center; margin-top: 10%">
  <div>
    <fa-icon icon="paper-plane" class="fa-5x" style="color: #0080c6"></fa-icon>
  </div>
  <div class="confirm_msg">Check Your Email!</div>

  <div class="frame">
    <div>A reset password link has been sent to your email.</div>
    <br />
    <div style="font-weight: 300; font-size: smaller">
      If you don't see it, you may need to check your spam folder.
    </div>
  </div>

  <div style="margin-top: 2em" *ngIf="!mobile">
    <a style="color: #1ca0da" [href]="link">Back to Login</a>
  </div>
</div>
